<template>
  <div>
    <vs-popup
      class="extended-popup"
      title=""
      :active.sync="agreementPopupActive">

      <div class="vs-con-loading__container indented-section" id="agtDiv-with-loading">
        <div class="mx-auto mt-5 inner-indented-section upload-new-agreement-form">
          <div class="vx-row flex-wrap title-bar">
            <h3>{{ agreementModalHeading }}</h3>
          </div>

          <hr>

          <div class="vx-row flex-wrap mt-8">
            <!-- <div class="vx-col w-full form-field pl-0">
              <label class="vs-input--label inline-flex pb-2">View Tucows Partners?</label>
              <vs-switch v-model="formData['isTucows']"></vs-switch>
            </div> -->

            <div class="vx-col w-full mb-2 form-field pl-0">
              <label class="vs-input--label inline-flex pb-2">Partner:</label>
              <treeselect
                name="client"
                class="w-full"
                v-model="formData['client_id']"
                :async="true"
                :load-options="clientSearchOptions"
                :multiple="false"
                :flat="true"
                :sort-value-by="formData['sortValueBy']"
                :default-expand-level="1"
                :clearable="true"
                v-validate="flags['enabledEntity'] ? 'required' : ''"
                data-vv-validate-on="change"
                placeholder=""
                :disabled="mode == 'view' || mode == 'edit'"/>
              <span class="text-danger text-sm" v-show="errors.has('client')">Required field</span>
            </div>

            <div class="vx-col w-full mb-2 form-field agt-name-field">
              <label class="vs-input--label inline-flex pb-2">Partner Full Name:</label>
              <vs-input
                class="w-full"
                name="Partner Name"
                v-model="formData['partner_name']"
                disabled/>
            </div>
          </div>

          <div class="vx-row flex-wrap mt-4">
            <div class="vx-col w-full mb-2 form-field pl-0">
              <label class="vs-input--label inline-flex pb-2">Type:</label>

              <v-select
                name="type"
                class="w-full"
                v-model="formData['type']"
                :options="formInit['types']"
                :closeOnSelect="true"
                :clearable="false"
                v-validate="'required'"
                data-vv-validate-on="change"
                :disabled="mode == 'view'">
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('type')">Required field</span>
            </div>

            <div class="vx-col w-full mb-2 form-field">
              <label class="vs-input--label inline-flex pb-2">Currency:</label>
              <v-select
                name="currencyType"
                class="w-full"
                :options="formCurrencies"
                :clearable="false"
                v-model="formData['currency_type']"
                v-validate="'required'"
                data-vv-validate-on="change"
                :disabled="mode == 'view'"></v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('currencyType')">Required field</span>
            </div>

            <div class="vx-col w-full mb-2 form-field">
              <label class="vs-input--label inline-flex pb-2">Conversion Rate (USD):</label>
              <vs-input
                class="w-full"
                v-validate="'required'"
                name="Conversion Rate"
                data-vv-validate-on="change"
                v-model="formData['conversion_rate']"
                :disabled="mode == 'view'"/>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Conversion Rate')">Required field</span>
            </div>
          </div>

          <div class="vx-row flex-wrap mt-4">


            <div class="vx-col w-full mb-2 form-field pl-0">
              <label class="vs-input--label inline-flex pb-2">Start date:</label>
              <div class="relative">
                <flat-pickr
                  class="w-full"
                  v-validate="'required'"
                  name="Start date"
                  :config="configFromdateTimePicker"
                  @on-change="onFromChange"
                  v-model="formData['start_date']"
                  data-vv-validate-on="change"
                  placeholder="YYYY-MM-DD"
                  :disabled="mode == 'view'"/>
                <!-- <vs-button class="absolute top-0 right-0 input-group" type="flat" icon-pack="feather" icon="icon-calendar" title="toggle" data-toggle></vs-button> -->
              </div>
              <span class="text-danger text-sm" v-show="errors.has('Start date')">Required field</span>
            </div>

            <div class="vx-col w-full mb-2 form-field">
              <label class="vs-input--label inline-flex pb-2">End date:</label>
              <div class="relative">
                <flat-pickr
                  class="w-full"
                  v-validate="'required'"
                  name="End date"
                  :config="configTodateTimePicker"
                  @on-change="onToChange"
                  v-model="formData['end_date']"
                  data-vv-validate-on="change"
                  placeholder="YYYY-MM-DD"
                  :disabled="mode == 'view'"/>
                <!-- <vs-button class="absolute top-0 right-0 input-group" type="flat" icon-pack="feather" icon="icon-calendar" title="toggle" data-toggle></vs-button> -->
              </div>
              <span class="text-danger text-sm" v-show="errors.has('End date')">Required field</span>
            </div>

            <div class="vx-col w-full mb-2 form-field agt-name-field">
              <label class="vs-input--label inline-flex pb-2">Agreement Name:</label>
              <vs-input
                class="w-full"
                v-validate="'required'"
                name="Agreement Name"
                data-vv-validate-on="change"
                v-model="formData['agreement_name']"
                :disabled="mode == 'view'"/>
              <span class="text-danger text-sm" v-show="errors.has('Agreement Name')">Required field</span>
            </div>
          </div>
        </div>

        <div class="mt-10 mb-5">
          <vs-collapse>
            <vs-collapse-item>
              <div slot="header">AGREEMENT DETAILS</div>
              <div class="form-actions">
                <vx-tooltip text="Add new row" position="top">
                  <vs-button
                    class="iconOnly"
                    color="dark"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="addAgreementDetailsRow"
                    :disabled="mode == 'view'"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Delete" position="top">
                  <vs-button
                    class="iconOnly"
                    color="dark"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    @click="deleteAgreementDetailsRow"
                    :disabled="mode == 'view'"
                  ></vs-button>
                </vx-tooltip>
              </div>

              <div>
                <table class="agreement-details-table" width="100%">
                  <tr>
                    <th class="checkbox-cell"></th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Category</th>
                    <th>Sub-Category</th>
                    <th>Actual Amount</th>
                    <th>Amount ($)</th>
                    <th>Cash Flow</th>
                  </tr>
                  
                  <tr v-for="(agtDetail, counter) in agtDetails" v-bind:key="counter">
                    <td class="checkbox-cell">
                      <vs-checkbox v-model="agtDetail.checkBox"></vs-checkbox>
                    </td>

                    <td>
                      <div>
                        <flat-pickr
                          :name="`start date-${counter}`"
                          v-model="agtDetail.start_date"
                          placeholder="YYYY-MM-DD"
                          class="w-full"
                          v-validate="'required'"
                          data-vv-validate-on="change"
                          :config="agtDetail.configFromdateTimePicker"
                          @on-change="onFromChangeAgtDetail($event, counter)"
                          :disabled="mode == 'view'" />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`start date-${counter}`)"
                          >Required field</span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <flat-pickr
                          :name="`end date-${counter}`"
                          v-model="agtDetail.end_date"
                          placeholder="YYYY-MM-DD"
                          class="w-full"
                          v-validate="'required'"
                          data-vv-validate-on="change"
                          :config="agtDetail.configTodateTimePicker"
                          @on-change="onToChangeAgtDetail($event, counter)"
                          :disabled="mode == 'view'" />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`end date-${counter}`)"
                          >Required field</span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <v-select
                          :name="`category-${counter}`"
                          class="w-full"
                          v-model="agtDetail.category"
                          append-to-body
                          :options="formCategory"
                          v-validate="'required'"
                          data-vv-validate-on="change"
                          :clearable="false"
                          :on-change="resetSubCategory(counter)"
                          :disabled="formData.type == '' || mode == 'view'" >
                          </v-select>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`category-${counter}`)"
                          >Required field</span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <v-select
                          :name="`subcategory-${counter}`"
                          class="w-full"
                          v-model="agtDetail.subCategory"
                          append-to-body
                          :options="formSubCategory(counter)"
                          v-validate="'required'"
                          data-vv-validate-on="change"
                          :clearable="false"
                          :disabled="agtDetail.category == '' || mode == 'view'" >
                          </v-select>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`sub-category-${counter}`)"
                          >Required field</span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <div class="inputPrefix">
                          <vs-input
                            :name="`actual amount-${counter}`"
                            class="w-full"
                            v-validate="'required'"
                            data-vv-validate-on="change"
                            v-model="agtDetail.actual_amount" 
                            :disabled="mode == 'view'" 
                            @change="calculateConvertedAmount(counter)"/>
                          <span class="currency-sign">{{
                            formData["showCurrencySign"]
                          }}</span>
                          <span
                            class="text-danger text-sm agt-currency-error"
                            v-show="errors.has(`actual amount-${counter}`)">
                            Required field
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div>
                        <vs-input
                          :name="`amount-${counter}`"
                          class="w-full"
                          v-validate="'required'"
                          data-vv-validate-on="change"
                          v-model="agtDetail.amount"
                          :disabled="true" />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has(`amount-${counter}`)">
                          Required field
                        </span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <div
                          class="inputPrefix text-center"
                          @click="openCashFlow(counter)">
                          <u> Add/View </u>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="checkbox-cell"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="total-amt-text text-right">
                      <span>TOTAL</span>
                    </td>
                    <td class="total-amt-text text-center">
                      <span class="inline-flex justify-end">
                        {{ formData["showCurrencySign"] }}
                        {{ formData["totalActualAmount"] }}
                      </span>
                    </td>
                    <td class="total-amt-text pr-4 text-center">
                      $ {{  formData["totalAmount"] }}
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>

        <div class="vx-row flex mb- mt-10">
          <div class="vx-col w-1/2 px-0">
            <label>{{ mode == 'view' ? 'Uploaded File(s):' : 'Upload File' }} <br />
              <div class="upload-input relative">
                <input
                  name="agtFile"
                  type="file"
                  id="file"
                  ref="agreementFile"
                  style="cursor: pointer; width: 100%; display:none;"
                  v-validate="!imgLoaded ? 'required' : ''"
                  class="absolute top-0 left-0 w-100 h-full z-10 opacity-0"
                  @click="isFileSelected"
                  @change="handleFileChange"
                  :disabled="mode == 'view'" />
                <vs-button
                  v-if="mode !== 'view'"
                  class="mt-2 upload-btn"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-file-text"
                  style="width: 100% !important;" @click="confirmAppendReplace">Click or Drag & Drop File Here</vs-button>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('agtFile')">
                  Required field
                </span>
              </div>
            </label>

            <div class="file-errors-wrap flex flex-wrap">
              <ul v-show="formData['fileName']" class="pt-2 pr-5">
                <li class="flex items-center" v-if="formData['fileName'] !== ''">
                  <p class="pr-1" :class=" formData['fileTypeError'] || formData['fileSizeError'] ? 'color-gray' : 'text-primary'">
                    {{ formData["fileName"] }}
                  </p>
                  <!-- //Hide remove icon if filesize or filetype error is there. -->
                  <vs-button v-show="!formData['fileTypeError'] && !formData['fileSizeError'] && formData['versionFiles'].length <= 1 && mode !== 'view'"
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    class="remove-agt-file-btn"
                    @click="formData.fileName !== '' ? removeAgtFile() : confirmAppendReplace()">
                  </vs-button>
                </li>
              </ul>

              <ul v-if="formData['versionFiles'].length" class="pt-2 pr-5">
                <li class="flex" v-for="(file, index) in formData['versionFiles']" :key="`file-${index}`">
                  <p class="pr-1" :class=" formData['fileTypeError'] || formData['fileSizeError'] ? 'color-gray' : 'text-primary'">
                    <span v-if="editAgreementData['filename'] && editAgreementData['filename'] !== '' && !editAgreementData['append']">{{ file.filename }}</span>
                    <a v-else :href="file.dropbox_link" target="_blank"><u> {{ file.filename }} </u></a>
                  </p>
                  <!-- //Hide remove icon if filesize or filetype error is there. -->
                  <vs-button v-show="!formData['fileTypeError'] && !formData['fileSizeError'] && formData['versionFiles'].length <= 1 && mode !== 'view' && (formData['versionFiles'].length == 1 && formData['fileName'] == '')"
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    class="remove-agt-file-btn"
                    @click="confirmAppendReplace()">
                  </vs-button>
                </li>
              </ul>

              <p v-show="formData['fileTypeError']" class="pt-2 text-danger">
                {{ formData["fileTypeError"] }}
              </p>
              <p v-show="formData['fileSizeError']" class="pt-2 text-danger">
                {{ formData["fileSizeError"] }}
              </p>
            </div>
          </div>

          <div class="vx-col w-1/2 upload-agt-btn mt-10 px-0">
            <div class="vx-row justify-end">
              <div class="p-2 mr-5">
                <vs-checkbox v-model="formData['isProvisionalAgt']" :disabled="mode == 'view'">Provisional Agreement</vs-checkbox>
              </div>

              <div class="p-2 mr-5">
                <vs-checkbox v-model="formData['isAppendedAgt']" disabled>Append Agreement</vs-checkbox>
              </div>

              <div>
                <vs-button
                  id="button-with-loading"
                  color="primary"
                  type="filled"
                  class="custom-btn ml-auto w-50"
                  @click="uploadAgreement()"
                  icon-after
                  v-if="mode !== 'view'" >{{ mode == 'new' ? 'Save' : 'Update' }}</vs-button>
                <p class="text-danger text-sm pt-2" v-show="cfError">
                  Please add cashflow to proceed
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- Cash Flow Popup Start -->
    <vs-popup class="cash-flow-popup" title="Cash Flow" :active.sync="cashFlowPopupActive">
      <div id="cashFlowDiv-with-loading" class="div-with-modal-loading vs-con-loading__container">
        <div>
          <div class="static-box-header">
            <div class="header">CASH FLOW</div>

            <div class="form-actions">
              <vx-tooltip text="Add new row" position="top">
                <vs-button
                  class="iconOnly"
                  color="dark"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="addCashFlowRow"
                  :disabled="mode == 'view'"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="Delete" position="top">
                <vs-button
                  class="iconOnly"
                  color="dark"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click="deleteCashFlowRow"
                  :disabled="mode == 'view'"></vs-button>
              </vx-tooltip>
            </div>
          </div>
          
          <div class="agreement-details-form table-form">
            <table class="agreement-details-table" width="100%">
              <tr>
                <th></th>
                <th>Month</th>
                <th>Actual Amount</th>
                <th>Amount ($)</th>
              </tr>

              <tr v-for="(cf, counter) in agtDetails[cfCounter].tempCashFlow" v-bind:key="counter" class="relative">
                <td>
                  <vs-checkbox v-model="cf.checkBox"></vs-checkbox>
                </td>

                <td>
                  <div>
                    <Datepicker
                      :format="customMonthFormatter"
                      :minimum-view="'month'"
                      :maximum-view="'year'"
                      :disabled-dates="cf.monthPickerConfig.disabledDates"
                      :name="`cf-month-${counter}`"
                      v-model="cf.month"
                      placeholder="MM-YYYY"
                      class="w-full"
                      v-validate="
                        formData['type'] === 'Pricing Discounts Only' ||
                        formData['type'] === 'Others'
                          ? ''
                          : 'required'"
                      :disabled="mode == 'view'">
                    </Datepicker>

                    <span class="text-danger text-sm" v-show="errors.has(`cf-month-${counter}`)">Required field</span>
                  </div>
                </td>

                <td>
                  <div>
                    <div class="inputPrefix">
                      <vs-input
                        :name="`cf-amount-${counter}`"
                        class="w-full"
                        v-validate="
                          formData['type'] === 'Pricing Discounts Only' ||
                          formData['type'] === 'Others'
                            ? ''
                            : 'required'
                        "
                        data-vv-validate-on="change"
                        v-model="cf.amount"
                        @change="updateTotalAndConv(counter)"
                        :disabled="mode == 'view'" />
                      <span class="currency-sign">{{
                        formData["showCurrencySign"]
                      }}</span>
                      <span
                        class="text-danger text-sm agt-currency-error"
                        v-show="errors.has(`cf-amount-${counter}`)">
                        Required field
                      </span>
                    </div>
                  </div>
                </td>
                
                <td>
                  <div>
                    <vs-input
                      :name="`cf-converted-amount-${counter}`"
                      class="w-full"
                      v-validate="
                        formData['type'] === 'Pricing Discounts Only' ||
                        formData['type'] === 'Others'
                          ? ''
                          : 'required'
                      "
                      data-vv-validate-on="change"
                      v-model="cf.converted_amount"
                      :disabled="true" />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has(`cf-converted-amount-${counter}`)">
                      Required field
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td></td>

                <td class="total-amt-text text-right">
                  <span class="w-1/2">TOTAL</span>
                </td>

                <td class="total-amt-text text-right">
                  <span class="inline-flex w-1/2 pr-4 justify-end">{{ formData["showCurrencySign"] }}{{ agtDetails[cfCounter]["totalActualCFAmount"] }}</span>
                </td>

                <td class="total-amt-text pr-4 text-right">
                  $ {{ agtDetails[cfCounter]["totalCFAmount"] }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="vx-row flex mb-20 justify-end">
          <div class="vx-col w-1/4 upload-agt-btn mt-12 px-0">
            <vs-button
              v-if="mode !== 'view'"
              id="button-with-loading"
              color="primary"
              type="filled"
              class="custom-btn ml-auto"
              @click="submitCashFlow()"
              :disabled="validateCFInputs"
              icon-after>Save</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <!-- Cash Flow Popup End -->

    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <ul>{{ customPromptError }}</ul>
      </div>
    </custom-prompt>

    <vs-prompt
      @accept="appendAgreement"
      @cancel="replaceAgreement"
      :acceptText="confirmPrompt['acceptText']"
      :cancelText="confirmPrompt['cancelText']"
      :title="confirmPrompt['title']"
      :color="confirmPrompt['color']"
      :active.sync="confirmPrompt['activePrompt']">
        {{ confirmPrompt['content'] }}
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import Datepicker from "vuejs-datepicker";
import moment from "moment";

import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  components: {
    "v-select": vSelect,
    flatPickr,
    Treeselect,
    Datepicker,
    CustomPrompt,
  },
  props: {
    agreementId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      agreementPopupActive: false,
      cfCounter: 0,
      configFromdateTimePicker: {
        maxDate: null,
      },
      configTodateTimePicker: {
        minDate: null,
      },
      agtDetails: [
        {
          checkBox: false,
          start_date: null,
          end_date: null,
          actual_amount: "",
          amount: "",
          category: "",
          subCategory: "",
          configFromdateTimePicker: {
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
          },
          // Cash Flow details
          tempCashFlow: [
            {
              checkBox: false,
              month: null,
              amount: "",
              converted_amount: "",
              monthPickerConfig: {
                disabledDates: {},
              },
            },
          ],
          cashFlow: [
            {
              checkBox: false,
              month: null,
              amount: "",
              converted_amount: "",
              monthPickerConfig: {
                disabledDates: {},
              },
            },
          ],
          totalCFAmount: "0",
          totalActualCFAmount: "0",
        },
      ],
      minStartDate: null,
      maxStartDate: null,
      minEndDate: null,
      maxEndDate: null,
      agreementData: null,
      formData: {
        // isTucows: false,
        Max_Start_date: null,
        type: "",
        start_date: null,
        end_date: null,
        currency_type: [],
        conversion_rate: "",
        agreement_name: "",
        client_id: null,
        new_reseller_id: "",
        unique_registrar_id: "",
        sortValueBy: "ORDER_SELECTED",
        agtDetailCounter: [],
        fileName: "",
        fileTypeError: "",
        fileSizeError: "",
        fileExtension: "",
        partner_name: "",
        totalActualAmount: "0",
        totalAmount: "0",
        showCurrencySign: "",
        selectedCurrencyName: "",
        versionFiles: [],
        selectedAgtName: {
          selectedType: "",
          selectedClient: "",
          selectedStartMonth: "",
          selectedStartMonthYear: "",
          selectedEndMonth: "",
          selectedEndMonthYear: "",
        },
        isProvisionalAgt: false,
        isAppendedAgt: false,
        cashFlowCounter: [],
      },
      USDRate: [],
      agreementResponseId: '',
      formInit: {
        types: [
          "MDF",
          "Comarketing",
          "MDF & Comarketing",
          "Pricing Discounts Only",
          "Others",
        ],
        categories: [
          {
            label: "Placements",
            value: "MDF",
          },
          {
            label: "Pricing Discounts Only",
            value: "MDF",
          },
          {
            label: "Website Placements",
            value: "Comarketing",
          },
          {
            label: "Events",
            value: "Comarketing",
          },
          {
            label: "Retargeting",
            value: "Comarketing",
          },
          {
            label: "Online Marketing",
            value: "Comarketing",
          },
          {
            label: "Email Marketing",
            value: "Comarketing",
          },
          {
            label: "Other Co-marketing",
            value: "Comarketing",
          },
          {
            label: "Website Placements",
            value: "MDF",
          },
          {
            label: "Events",
            value: "MDF",
          },
          {
            label: "Retargeting",
            value: "MDF",
          },
          {
            label: "Online Marketing",
            value: "MDF",
          },
          {
            label: "Email Marketing",
            value: "MDF",
          },
          {
            label: "Other Co-marketing",
            value: "MDF",
          },
          {
            label: "Pricing Discounts Only",
            value: "Pricing Discounts Only",
          },
          {
            label: "Others",
            value: "Others",
          },
        ],
        currencies: [],
        currencyRates: [],
      },
      flags: {
        isBtnDisabled: true,
        collapseOpen: true,
      },
      cashFlowPopupActive: false,
      dataFetch: false,
      editAgreementData: null,
      imgLoaded: false,
      cfError: false,
      isEdit: false,
      agreementModalHeading: 'Upload New Agreement',
      mode: 'new',
      // Custom Dialog props
      customPrompt: {
        activePrompt: false,
        title: '',
        buttonText: '',
        type: '',
        color: '',
        classList: '',
        accept: null
      },
      confirmPrompt: {
        activePrompt: false,
        title: '',
        content: '',
        acceptText: '',
        cancelText: '',
        color: '',
      },
      clientDefaultOptions: [],
      customPromptError: null,
    };
  },
  watch: {
    "formData.client_id"(val) {
      if (val) {
        if (val && val !== "") {
          val = val.split("-");
        } else {
          this.formData["unique_registrar_id"] = "";
          this.formData["new_reseller_id"] = "";
        }
        if (val && val.length) {
          if (val[0] === "CNIC") {
            this.formData["unique_registrar_id"] = val[1];
            this.formData["new_reseller_id"] = "";
            this.formData["selectedAgtName"]["selectedClient"] = val[3]
              .split(" ")
              .join("-");
            this.formData['partner_name'] = val[3];
          } else if (val[0] === "PROMO") {
            this.formData["new_reseller_id"] = val[1];
            this.formData["unique_registrar_id"] = "";
            this.formData["selectedAgtName"]["selectedClient"] = val[3]
              .split(" ")
              .join("-");
            this.formData['partner_name'] = val[3];
            if (val[3] && val[3] === "SAME") {
              this.formData["selectedAgtName"]["selectedClient"] = val[5]
                .split(" ")
                .join("-");
              this.formData["unique_registrar_id"] = val[2];
              this.formData['partner_name'] = val[3];
            }
          }
        }
        this.agtNameFormations();
      } else {
        this.formData["client_id"] = null;
        this.formData["unique_registrar_id"] = "";
        this.formData["new_reseller_id"] = "";
      }
    },
    "formData.type"(val) {
      if (this.dataFetch) {
        if (val) {
          if (val == "Comarketing") {
            this.formData["selectedAgtName"]["selectedType"] = "CoM";
          } else if (val == "MDF & Comarketing") {
            this.formData["selectedAgtName"]["selectedType"] = "MDF_CoM";
          } else if (val == "Pricing Discounts Only") {
            this.formData["selectedAgtName"]["selectedType"] = "Pricing_Disc";
          } else {
            this.formData["selectedAgtName"]["selectedType"] = val;
          }

          this.agtDetails.forEach((x) => {
            x.category = "";
            x.subCategory = "";
          });
          this.agtNameFormations();
        }
      }
    },
    "formData.start_date"(val) {
      if (val) {
        var startDate = this.$moment(val);
        this.formData["selectedAgtName"]["selectedStartMonth"] =
          startDate.format("MMM");
        this.formData["selectedAgtName"]["selectedStartMonthYear"] =
          startDate.format("YY");
        this.agtNameFormations();
        this.minEndDate = val;
        this.minStartDate = val;
      }
    },
    "formData.end_date"(val) {
      if (val) {
        var endDate = this.$moment(val);
        this.formData["selectedAgtName"]["selectedEndMonth"] =
          endDate.format("MMM");
        this.formData["selectedAgtName"]["selectedEndMonthYear"] =
          endDate.format("YY");
        this.agtNameFormations();
        this.maxStartDate = val;
        this.maxEndDate = val;
      }
    },
    "formData.currency_type"(val) {
      if (val) {
        this.formData["showCurrencySign"] = val.sign;
        var inputCurrencyRate = this.formConversionRate
          .filter((x) => x["label"] == val["label"].split("-")[0].trim())
          .map((x) => x.value);
        this.USDRate = this.formConversionRate
          .filter((x) => x["label"] == "USD")
          .map((x) => x.value);
        var convRate = (1 / inputCurrencyRate) * this.USDRate;
        this.formData["conversion_rate"] = convRate.toFixed(3);
        this.calcTotalAmount();
        this.calcCFTotalAmount();
      }
    },
    "formData.conversion_rate"(val) {
      this.calcTotalAmount();
      this.calcCFTotalAmount();
    },
    agreementPopupActive(val) {
      this.checkCollapseOpen();
      if (!val) {
        this.resetAgreement();
        this.errors.clear();
      }
    },
    agtDetails: {
      deep: true,
      handler() {
        this.getAgtDetailsRowIndex();
        this.getCashFlowRowIndex();
        this.calcTotalActualAmount();
        this.calcTotalAmount();
      },
    },
    cashFlowPopupActive(val) {
      if (!val) {
        this.agtDetails[this.cfCounter]["tempCashFlow"] = JSON.parse(
          JSON.stringify(this.agtDetails[this.cfCounter]["cashFlow"])
        );
      } else {
        this.disableDatesMonthPicker();
      }
    },
    // NOTE: Vuex master data fetch
    clientOptions() {
      return this.$store.getters.getClientOptions;
    },
    formCurrencies() {
      return this.$store.getters.formCurrencies;
    },
  },
  computed: {
    user_details() {
      return JSON.parse(localStorage.getItem('userDetails'))
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    formCategory: function () {
      var typeVal = this.formData["type"];

      if (typeVal) {
        if (typeVal !== "MDF & Comarketing") {
          return this.formInit["types"].filter((x) => typeVal.includes(x));
        } else {
          return this.formInit["types"].filter((x) => typeVal !== x);
        }
      } else {
        return this.formInit["types"].filter((x) => typeVal !== x);
      }
    },
    formSubCategory() {
      return (counter) => {
        var typeVal = this.agtDetails[counter].category;
        if (typeVal) {
          if (typeVal !== "MDF & Comarketing") {
            return this.formInit["categories"].filter((x) =>
              typeVal.includes(x["value"])
            );
          } else {
            return this.formInit["categories"];
          }
        } else {
          return this.formInit["categories"];
        }
      };
    },
    formConversionRate: function () {
      let conversionArray = [];
      let objKeys = Object.keys(this.formInit["currencyRates"]["rates"]);
      let objValues = Object.values(this.formInit["currencyRates"]["rates"]);
      for (let i = 0; i < objKeys.length; i++) {
        let object = {
          label: objKeys[i],
          value: objValues[i],
        };
        conversionArray.push(object);
      }
      return conversionArray;
    },
    validateCFInputs: function () {
      return this.agtDetails[this.cfCounter]["tempCashFlow"].some(
        (el) =>
          el.month === null || el.amount === "" || el.converted_amount === ""
      );
    },
    // NOTE: Vuex master data fetch
    clientOptions() {
      return this.$store.getters.getClientOptions;
    },
    formCurrencies() {
      return this.$store.getters.formCurrencies;
    },
  },
  methods: {
    validateCashflow() {
      if(this.formData['type'] !== 'Pricing Discounts Only' && this.formData['type'] !== 'Others') {
        let valid = true;
        this.agtDetails.forEach((x) => {
          if (x.cashFlow.some((y) => !y.month || y.amount == "")) {
            valid = false;
          }
        });
        return valid;

      } else {
        return true;
      }
    },
    clientSearchOptions({ action, searchQuery, callback }) {
      // TODO: Variable URL if Tucows switch is on
      if (action === ASYNC_SEARCH) {
          // if(this.formData.isTucows) {
            this.$axiosSecure.get(`/v2/tucows/unique-registrars/${searchQuery}`)
              .then(response => {
                  let clientsList = response.data;

                  var transformedClientsList = [];

                  for (var client of clientsList) {
                      var temp = {
                          id:
                            "CNIC-" +
                            client["id"] +
                            "-" +
                            client["country_id"] +
                            "-" +
                            client["name"],
                          label: client["name"],
                          isDisabled: this.user_details.role == "channel_user" ? ((client["unique_registrar_client_am"] && client["unique_registrar_client_am"].length && client["unique_registrar_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(client["unique_registrar_client_am"][0]["user_id"]) == -1) : false,
                          children: client["new_reseller"].length ? [] : undefined,
                          tucows_registrar: client.tucows_registrar.map(x => { return { value: x.id, label: client.name, tucows_name: x.name, unique_registrar_id: client["id"] }})
                      };

                      if (client["new_reseller"].length) {
                          // Push resellers into obj
                          for (var reseller of client["new_reseller"]) {
                              temp["children"].push({
                                  id:
                                    reseller["name"] === client["name"]
                                      ? "PROMO-" +
                                      reseller["id"] +
                                      "-" +
                                      client["id"] +
                                      "-" +
                                      "SAME-" +
                                      client["country_id"] +
                                      "-" +
                                      reseller["name"]
                                      : "PROMO-" +
                                      reseller["id"] +
                                      "-" +
                                      client["id"] +
                                      "-" +
                                      reseller["name"],
                                  label: reseller["name"],
                                  isDisabled: this.user_details.role == "channel_user" ? ((reseller["new_reseller_client_am"] && reseller["new_reseller_client_am"].length && reseller["new_reseller_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(reseller["new_reseller_client_am"][0]["user_id"]) == -1) : false,
                                  tucows_registrar: reseller["name"] === client["name"] ? client.tucows_registrar.map(x => { return { value: x.id, label: client.name, tucows_name: x.tucows_name, unique_registrar_id: client["id"] }}) : []
                              });
                          }
                      }

                      transformedClientsList.push(temp);
                  }

                  callback(null, transformedClientsList);
              })
              .catch(error => {
                  console.log("Entity Search Error", error);
              })
          // } else {
          //   this.$axiosSecure.get(`/v2/unique-registrars/${searchQuery}`)
          //   .then(response => {
          //       let clientsList = response.data;
  
          //       var transformedClientsList = [];
  
          //       for (var client of clientsList) {
          //           var temp = {
          //               id:
          //                   "CNIC-" +
          //                   client["id"] +
          //                   "-" +
          //                   client["country_id"] +
          //                   "-" +
          //                   client["name"],
          //               label: client["name"],
          //               isDisabled: this.user_details.role == "channel_user" ? ((client["unique_registrar_client_am"] && client["unique_registrar_client_am"].length && client["unique_registrar_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(client["unique_registrar_client_am"][0]["user_id"]) == -1) : false,
          //               children: client["new_reseller"].length ? [] : undefined,
          //               new_registrar: client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }})
          //           };
  
          //           if (client["new_reseller"].length) {
          //               // Push resellers into obj
          //               for (var reseller of client["new_reseller"]) {
          //                   temp["children"].push({
          //                       id:
          //                           reseller["name"] === client["name"]
          //                               ? "PROMO-" +
          //                               reseller["id"] +
          //                               "-" +
          //                               client["id"] +
          //                               "-" +
          //                               "SAME-" +
          //                               client["country_id"] +
          //                               "-" +
          //                               reseller["name"]
          //                               : "PROMO-" +
          //                               reseller["id"] +
          //                               "-" +
          //                               client["id"] +
          //                               "-" +
          //                               reseller["name"],
          //                       label: reseller["name"],
          //                       isDisabled: this.user_details.role == "channel_user" ? ((reseller["new_reseller_client_am"] && reseller["new_reseller_client_am"].length && reseller["new_reseller_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(reseller["new_reseller_client_am"][0]["user_id"]) == -1) : false,
          //                       new_registrar: reseller["name"] === client["name"] ? client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }}) : []
          //                   });
          //               }
          //           }
  
          //           transformedClientsList.push(temp);
          //       }
  
          //       callback(null, transformedClientsList);
          //   })
          //   .catch(error => {
          //       console.log("Entity Search Error", error);
          //   })
          // }
      }
    },
    flattenArr(array) {
      var self = this;
      var result = [];
      array.forEach(function (a) {
        result.push(a);
        if (a.children && Array.isArray(a.children)) {
          result = result.concat(self.flattenArr(a.children));
        }
      });
      return result;
    },
    resetSubCategory(counter) {
      let cat = this.agtDetails[counter].category;
      let subCat = this.agtDetails[counter].subCategory;
      if (subCat && subCat.hasOwnProperty("value") && subCat["value"] !== cat) {
        this.agtDetails[counter].subCategory = {};
      }
    },
    formAgreementData(agreementData) {
      var self = this;
      self.dataFetch = false;
      this.agreementData = agreementData;
      // Transform currency obj
      agreementData["currency"] = this.formCurrencies.find(
        (el) => el.value === agreementData["currency_id"]
      );

      // Transform Client obj
      var type = agreementData["unique_registrar_id"] ? "CNIC" : "PROMO";
      var typeId = agreementData["unique_registrar_id"]
        ? agreementData["unique_registrar_id"]
        : agreementData["new_reseller_id"];
      var flattenedClientOptions = self.flattenArr(this.clientOptions);
      agreementData["client_id"] = flattenedClientOptions.find((el) => {
        if(el.id.split("-")[0] === type && el.id.split("-")[1] == typeId) {
          console.log('el :>> ', el);
        }
        return el.id.split("-")[0] === type && el.id.split("-")[1] == typeId;
      }).id;

      this.formData["type"] = agreementData["type"];
      this.formData["start_date"] = agreementData["start_date"];
      this.formData["end_date"] = agreementData["end_date"];
      this.formData["currency_type"] = agreementData["currency"];
      this.formData["conversion_rate"] = agreementData["conversion_rate"];
      this.formData["agreement_name"] = agreementData["filename"];
      this.formData["client_id"] = agreementData["client_id"]; // TBD
      this.formData["new_reseller_id"] = agreementData["new_reseller_id"];
      this.formData["unique_registrar_id"] =
        agreementData["unique_registrar_id"];
      this.formData["sortValueBy"] = "ORDER_SELECTED";
      this.formData["agtDetailCounter"] = []; // TBD
      if(agreementData.approved_at) {
        this.formData["versionFiles"] = (agreementData["dropbox_detail"] && agreementData["dropbox_detail"].length) ? agreementData["dropbox_detail"].map(x => {
          return {
            filename: x.filename,
            path: x.path,
            dropbox_link: x.dropbox_link
          }
        }) : [];
        if(agreementData['append']) {
          this.formData["versionFiles"].push({filename: agreementData["filename"], path: null, dropbox_link: `${process.env.VUE_APP_API}/storage/agreement_temp/${agreementData['temp_filename']}`});
        }
      } else {
        this.formData["fileName"] = agreementData["filename"];
        this.formData["fileExtension"] = this.formData["fileName"]
        .split(".")
        .pop();
      }
      this.formData["totalActualAmount"] = agreementData["agreement_detail"].length ? agreementData["agreement_detail"][0]["total_amount"] : "0";
      this.formData["totalAmount"] = agreementData["agreement_detail"][0] ? agreementData["agreement_detail"][0]["total_converted_amount"] : "0";
      this.formData["showCurrencySign"] = agreementData["currency"].sign;
      this.formData["selectedCurrencyName"] = agreementData["currency"].name;

      if (this.formData["type"] == "Comarketing") {
        this.formData["selectedAgtName"]["selectedType"] = "CoM";
      } else if (this.formData["type"] == "MDF & Comarketing") {
        this.formData["selectedAgtName"]["selectedType"] = "MDF&CoM";
      } else {
        this.formData["selectedAgtName"]["selectedType"] =
          this.formData["type"];
      }

      this.formData["isProvisionalAgt"] = agreementData["provisional"] ? true : false;
      this.formData["isAppendedAgt"] = agreementData["append"] ? true : false;
      this.formData["cashFlowCounter"] = []; // TBD

      agreementData["agreement_detail"].forEach((el, index) => {
        let cf = [];
        el["agreement_cash_flow"].forEach((cfEl, cfIndex) => {
          cf.push({
            checkBox: false,
            cashflow_id: cfEl["id"],
            month: cfEl["month"],
            amount: cfEl["amount"],
            converted_amount: cfEl["converted_amount"],
            monthPickerConfig: {
              disabledDates: {},
            },
          });
        });

        let obj = {
          checkBox: false,
          agreement_detail_id: el["id"],
          start_date: el["start_date"],
          end_date: el["end_date"],
          actual_amount: el["amount"],
          amount: el["converted_amount"],
          configFromdateTimePicker: {
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
          },
          totalCFAmount: el["agreement_cash_flow"]
            .map((x) => x.converted_amount)
            .reduce((result, item) => {
              return result + Number(item);
            }, 0),
          totalActualCFAmount: el["agreement_cash_flow"]
            .map((x) => x.amount)
            .reduce((result, item) => {
              return result + Number(item);
            }, 0),
          cashFlow: cf,
          tempCashFlow: cf,
        };
        if (index == 0) {
          this.agtDetails.splice(0);
        }
        this.agtDetails.push(obj);
      });
    },
    formCategoryForAgreements(agreementData) {
      return new Promise((resolve, reject) => {
        var self = this;
        agreementData["agreement_detail"].forEach((el, index) => {
          self.$set(
            self.agtDetails[index],
            "category",
            self.formCategory.find((cat) => cat === el["category"])
          );
        });

        resolve(true);
      });
    },
    formSubCategoryForAgreements(agreementData) {
      return new Promise((resolve, reject) => {
        var self = this;
        agreementData["agreement_detail"].forEach((el, index) => {
          self.$set(self.agtDetails[index], "subCategory", {
            label: el["sub_category"],
            value: el["category"],
          });
        });

        resolve(true);
      });
    },
    customMonthFormatter(date) {
      return moment(date).format("MMMM YYYY");
    },
    updateTotalAndConv(index) {
      this.calculateCFConvertedAmount(index);
      this.calcCFTotalAmount();
      this.calcCFTotalActualAmount();
    },
    openLoadingInAgtDiv() {
      this.$vs.loading({
        container: "#agtDiv-with-loading",
        scale: 0.6,
      });
    },
    hideLoadingInAgtDiv() {
      this.$vs.loading.close("#agtDiv-with-loading > .con-vs-loading");
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
      /**set min and max date for agt details calender */
      this.agtDetails.forEach((el, i) => {
        this.$set(el.configTodateTimePicker, "minDate", dateStr);
        this.$set(el.configFromdateTimePicker, "minDate", dateStr);
      });
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
      /**set min and max date for agt details calender */
      this.agtDetails.forEach((el, i) => {
        this.$set(el.configFromdateTimePicker, "maxDate", dateStr);
        this.$set(el.configTodateTimePicker, "maxDate", dateStr);
      });
    },
    onFromChangeAgtDetail(event, counter) {
      this.$set(
        this.agtDetails[counter].configTodateTimePicker,
        "minDate",
        event[0]
      );
    },
    onToChangeAgtDetail(event, counter) {
      this.$set(
        this.agtDetails[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },
    addAgreementDetailsRow() {
      this.agtDetails.push({
        checkBox: false,
        start_date: null,
        end_date: null,
        actual_amount: "",
        amount: "",
        category: [],
        configFromdateTimePicker: {
          maxDate: this.maxStartDate,
          minDate: this.minStartDate,
        },
        configTodateTimePicker: {
          minDate: this.minEndDate,
          maxDate: this.maxEndDate,
        },
        tempCashFlow: [
          {
            checkBox: false,
            month: null,
            amount: "",
            converted_amount: "",
            monthPickerConfig: {
              disabledDates: {},
            },
          },
        ],
        cashFlow: [
          {
            checkBox: false,
            month: null,
            amount: "",
            converted_amount: "",
            monthPickerConfig: {
              disabledDates: {},
            },
          },
        ],
      });
    },
    getAgtDetailsRowIndex() {
      this.formData["agtDetailCounter"] = [];
      this.agtDetails.forEach((element, index) => {
        if (element.checkBox == true) {
          var count = index;
          this.formData["agtDetailCounter"].push(count);
        }
      });
    },
    deleteAgreementDetailsRow() {
      var rowIndex = this.formData["agtDetailCounter"];
      this.agtDetails = this.agtDetails.filter(
        (el, index) => !rowIndex.includes(index)
      );
      if (this.agtDetails.length == 0) {
        this.addAgreementDetailsRow();
      }
    },
    calcTotalActualAmount() {
      var getActAmt = [];
      this.agtDetails.forEach((el) => {
        if (el["actual_amount"].length) {
          var actAmt = parseInt(el["actual_amount"]);
          getActAmt.push(actAmt);
        }

        if (getActAmt.length) {
          const initialValue = 0;
          this.formData["totalActualAmount"] = getActAmt.reduce(
            (previousValue, currentValue) => parseFloat(previousValue) + parseFloat(currentValue),
            parseFloat(initialValue)
          );
        } else {
          this.formData["totalActualAmount"] = 0;
        }
      });
    },
    calcTotalAmount() {
      var getAmt = [];
      this.agtDetails.forEach((el) => {
        if(el.agreement_detail_id) {
          getAmt.push(el["amount"]);
        }
        
        else if (el["actual_amount"].length) {
          el["amount"] = Math.round(
            el["actual_amount"] * this.formData["conversion_rate"]
          );
          getAmt.push(el["amount"]);
        } else {
          el["amount"] = 0;
        }


        if (getAmt.length) {
          const initialValue = 0;
          this.formData["totalAmount"] = getAmt.reduce(
            (previousValue, currentValue) => parseFloat(previousValue) + parseFloat(currentValue),
            parseFloat(initialValue)
          );
        } else {
          this.formData["totalAmount"] = 0;
        }
      });
    },
    calculateConvertedAmount(index) {
      var getAmt = [];
      this.agtDetails.forEach((el, idx) => {
        if (el["actual_amount"].length) {
          if(index == idx) {
            el["amount"] = Math.round(el["actual_amount"] * this.formData["conversion_rate"]);
          }

          getAmt.push(el["amount"]);
        } else {
          el["amount"] = 0;
        }


        if (getAmt.length) {
          const initialValue = 0;
          this.formData["totalAmount"] = getAmt.reduce(
            (previousValue, currentValue) => parseFloat(previousValue) + parseFloat(currentValue),
            parseFloat(initialValue)
          );
        } else {
          this.formData["totalAmount"] = 0;
        }
      });
    },
    calcCFTotalActualAmount() {
      var getActAmt = [];
      this.agtDetails[this.cfCounter]["tempCashFlow"].forEach((el) => {
        if (el["amount"].length) {
          var actAmt = parseInt(el["amount"]);
          getActAmt.push(actAmt);
        }

        if (getActAmt.length) {
          const initialValue = 0;
          this.agtDetails[this.cfCounter]["totalActualCFAmount"] =
            getActAmt.reduce(
              (previousValue, currentValue) => previousValue + currentValue,
              initialValue
            );
        } else {
          this.agtDetails[this.cfCounter]["totalActualCFAmount"] = 0;
        }
      });
    },
    calcCFTotalAmount() {
      var getAmt = [];
      this.agtDetails[this.cfCounter]["tempCashFlow"].forEach((el) => {
        if(el.cashflow_id) {
          getAmt.push(parseFloat(el["converted_amount"]));
        }

        else if (el["amount"].length) {
          el["converted_amount"] = Math.round(
            el["amount"] * this.formData["conversion_rate"]
          );
          getAmt.push(el["converted_amount"]);
        } else {
          el["converted_amount"] = 0;
        }

        if (getAmt.length) {
          const initialValue = 0;
          this.agtDetails[this.cfCounter]["totalCFAmount"] = getAmt.reduce(
            (previousValue, currentValue) => previousValue + currentValue,
            initialValue
          );
        } else {
          this.agtDetails[this.cfCounter]["totalCFAmount"] = 0;
        }
      });
    },
    calculateCFConvertedAmount(index) {
      var getAmt = [];
      this.agtDetails[this.cfCounter]["tempCashFlow"].forEach((el, idx) => {
        if (el["amount"].length) {
          if(index == idx) {
            el["converted_amount"] = Math.round(el["amount"] * this.formData["conversion_rate"]);
          }
          getAmt.push(el["converted_amount"]);
        } else {
          el["converted_amount"] = 0;
        }

        if (getAmt.length) {
          const initialValue = 0;
          this.agtDetails[this.cfCounter]["totalCFAmount"] = getAmt.reduce(
            (previousValue, currentValue) => previousValue + currentValue,
            initialValue
          );
        } else {
          this.agtDetails[this.cfCounter]["totalCFAmount"] = 0;
        }
      });
    },
    formatCashFlow(index) {
      let self = this;
      let cashFlowArr = [];
      let months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];

      this.agtDetails[index]["cashFlow"].forEach((el) => {
        if(el.month) {
          cashFlowArr.push({
            cashflow_id: (self.mode == 'edit' && self.editAgreementData && self.editAgreementData.approved_at) ? undefined : el.cashflow_id ? el.cashflow_id : null,
            month: months[new Date(el.month).getMonth()] + "-" + new Date(el.month).getFullYear(),
            amount: Math.round(el.amount * 100) / 100,
            converted_amount: Math.round(el.converted_amount * 100) / 100,
          });
        }
      });

      return cashFlowArr;
    },
    formatCashFlowForPaytrack(index) {
      let self = this;
      let cashFlowArr = [];
      let months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];

      this.agtDetails[index]["cashFlow"].forEach((el) => {
        if(el.month) {
          cashFlowArr.push({
            id: el.id ? el.id : null,
            agreement_detail_id: this.agtDetails[index].agreement_detail_id,
            month: el.id ? el.month : months[new Date(el.month).getMonth()] + "-" + new Date(el.month).getFullYear(),
            amount: Math.round(el.amount * 100) / 100,
            converted_amount: Math.round(el.converted_amount * 100) / 100,
          });
        }
      });

      return cashFlowArr;
    },
    disableDatesMonthPicker() {
      let start_date = this.agtDetails[this.cfCounter]["start_date"],
        end_date = this.agtDetails[this.cfCounter]["end_date"];

      if (start_date || end_date) {
        this.agtDetails[this.cfCounter]["tempCashFlow"].forEach((el) => {
          this.$set(el.monthPickerConfig, "disabledDates", {
            customPredictor: function (date) {
              // New Logic (Add buffer of 3 months after the year ends)
              let parsedStartDate = Date.parse(new Date(start_date)),
                parsedDate = Date.parse(date),
                tempEndDate = new Date(end_date),
                endDateAfterThreeMonths = tempEndDate.setUTCMonth(
                  tempEndDate.getUTCMonth() + 3
                ),
                parsedEndDateAfterThreeMonths = Date.parse(
                  new Date(endDateAfterThreeMonths)
                );

              if (
                parsedDate < parsedStartDate ||
                parsedDate > parsedEndDateAfterThreeMonths
              ) {
                return true;
              }
            },
          });
        });
      }
    },
    agtNameFormations() {
      var selectedYear = "";
      if (
        this.formData["selectedAgtName"]["selectedStartMonthYear"] ===
        this.formData["selectedAgtName"]["selectedEndMonthYear"]
      ) {
        selectedYear = `${this.formData["selectedAgtName"]["selectedStartMonth"]}`;
      } else {
        selectedYear = `${
          this.formData["selectedAgtName"]["selectedStartMonth"] +
          "-" +
          this.formData["selectedAgtName"]["selectedStartMonthYear"]
        }`;
      }

      let part1 = this.formData["selectedAgtName"]["selectedType"],
        part2 = this.formData["selectedAgtName"]["selectedClient"],
        part3 = selectedYear,
        part4 = this.formData["selectedAgtName"]["selectedEndMonth"],
        part5 = this.formData["selectedAgtName"]["selectedEndMonthYear"],
        part6 = this.formData["fileExtension"];

      this.formData["agreement_name"] = `${
        part1 != "" && part1 != undefined ? part1 : ""
      }${part2 != "" && part2 != undefined ? "-" + part2 : ""}${
        part3 != "" && part3 != undefined ? "-" + part3 : ""
      }${part4 != "" && part4 != undefined ? "-" + part4 : ""}${
        part5 != "" && part5 != undefined ? "-" + part5 : ""
      }${part6 != "" && part6 != undefined ? "." + part6 : ""}`;

      this.formData["agreement_name"] = this.formData["agreement_name"]
        .split(" ")
        .join("_");
    },
    confirmAppendReplace() {
      if(this.mode == 'edit' && this.formData['versionFiles'].length <= 1 && this.formData['fileName'] == '') {
        this.confirmPrompt['acceptText'] = 'Append';
        this.confirmPrompt['cancelText'] = 'Replace';
        this.confirmPrompt['title'] = 'Append or Replace Agreement?'
        this.confirmPrompt['content'] = 'Do you want to append to the existing agreement?'
        this.confirmPrompt['color'] = 'warning'
        this.confirmPrompt['activePrompt'] = true;
      } else {
        if(this.formData['versionFiles'].length > 1) {
          this.$set(this.formData, 'isAppendedAgt', true);
        }
        this.$refs.agreementFile.click();
      }
    },
    appendAgreement() {
      this.$set(this.formData, 'isAppendedAgt', true);
      this.$refs.agreementFile.click();
    },
    replaceAgreement() {
      this.formData["versionFiles"] = []
      this.formData["fileName"] = "";
      this.$refs.agreementFile.click();
    },
    isFileSelected(event) {
      var target = event.target || event.srcElement;
      if (target.value.length == 0) {
        // NOTE: If uploaded/selected agreement is removed, revert version files
        if(this.editAgreementData && this.editAgreementData.dropbox_detail && this.editAgreementData.dropbox_detail.length) {
          let dropbox_detail_copy = JSON.parse(JSON.stringify(this.editAgreementData['dropbox_detail']));
          this.formData["versionFiles"] = (dropbox_detail_copy && dropbox_detail_copy.length) ? dropbox_detail_copy.map(x => {
            return {
              filename: x.filename,
              path: x.path,
              dropbox_link: x.dropbox_link
            }
          }) : [];
        }
      }
    },
    handleFileChange(event) {
      this.formData["fileTypeError"] = "";
      this.formData["fileSizeError"] = "";
      this.formData["fileExtension"] = "";
      //check File Size
      this.formData["fileName"] = event.target.files[0].name;

      this.formData["fileExtension"] = this.formData["fileName"]
        .split(".")
        .pop();
      this.agtNameFormations();

      //Check File Type
      this.formData["filePath"] = event.target.value;

      // Allowing file type
      var allowedExtensions = /(\.doc|\.docx|\.pdf|\.jpg|\.jpeg|\.png)$/i;

      if (!allowedExtensions.exec(this.formData["filePath"])) {
        this.formData["fileTypeError"] =
          "Invalid file (Please upload .pdf, .jpg, .jpeg, .png, .doc or .docx file under 25mb)";
        return false;
      }

      //Check FileSize
      var ogFileSize = event.target.files[0].size;
      var fileSize = Math.round(ogFileSize / 1024);

      if (fileSize >= 25600) {
        this.formData["fileSizeError"] = "Please select a file under 25mb";
      }

      if (this.imgLoaded) {
        this.imgLoaded = false;
      }

      if(!this.formData['isAppendedAgt']) {
        this.formData['versionFiles'] = [];
      }
    },
    removeAgtFile() {
      this.$refs.agreementFile.value = null;
      this.formData["fileName"] = "";
      this.formData["fileTypeError"] = "";
      this.formData["fileSizeError"] = "";
      this.formData["fileExtension"] = "";
      this.agtNameFormations();

      if(this.formData["isAppendedAgt"]) {
        this.formData["isAppendedAgt"] = false;
      }
      
      // NOTE: If uploaded/selected agreement is removed, revert version files
      if(this.editAgreementData && this.editAgreementData.dropbox_detail && this.editAgreementData.dropbox_detail.length) {
        let dropbox_detail_copy = JSON.parse(JSON.stringify(this.editAgreementData['dropbox_detail']));
        this.formData["versionFiles"] = (dropbox_detail_copy && dropbox_detail_copy.length) ? dropbox_detail_copy.map(x => {
          return {
            filename: x.filename,
            path: x.path,
            dropbox_link: x.dropbox_link
          }
        }) : [];
      }
    },
    checkCollapseOpen() {
      const itemParentTop = document.getElementById("agtDiv-with-loading");
      const itemParent = itemParentTop.querySelector(".vs-collapse-item");
      if (!itemParent.classList.contains("open-item")) {
        setTimeout(() => {
          itemParent.querySelector(".vs-collapse-item--header").click();
        }, 100);
      }
    },
    async validatePaytrack() {
      let url = process.env.VUE_APP_PT_VALIDATION_API;

      let agtDetailsData = this.agtDetails.map((x, index) => {
        return {
          id: this.editAgreementData && this.editAgreementData.agreement_detail && this.editAgreementData.agreement_detail.length && this.editAgreementData.agreement_detail[index]
          ? this.editAgreementData.agreement_detail[index].id
          : null,
          agreement_new_id: this.editAgreementData && this.editAgreementData['id'] ? this.editAgreementData['id'] : null,
          start_date: x.start_date,
          end_date: x.end_date,
          category: x.subCategory.value,
          sub_category: x.subCategory.label,
          amount: x.actual_amount,
          converted_amount: x.amount,
          total_amount:
            Math.round(this.formData["totalActualAmount"] * 100) / 100,
          total_converted_amount:
            Math.round(this.formData["totalAmount"] * 100) / 100,
          agreement_cash_flow: this.formatCashFlowForPaytrack(index),
        };
      });

      let payload = {
        agreement: {
          id: this.editAgreementData['id'],
          user_id: this.editAgreementData['user_id'],
          unique_registrar_id: this.editAgreementData['unique_registrar_id'],
          new_reseller_id: this.editAgreementData['new_reseller_id'],
          registrar_id: this.editAgreementData['registrar_id'],
          reseller_id: this.editAgreementData['reseller_id'],
          dropbox_detail: this.formData['dropbox_detail'],
          type: this.formData['type'],
          start_date: this.formData['start_date'],
          end_date: this.formData['end_date'],
          currency_id: this.formData['currency_type']['value'],
          conversion_rate: this.formData['conversion_rate'],
          status: this.editAgreementData['status'],
          provisional: this.editAgreementData['provisional'],
          approved_by: this.editAgreementData['approved_by'],
          approved_at: this.editAgreementData['approved_at'],
          rejected_by: this.editAgreementData['rejected_by'],
          rejected_at: this.editAgreementData['rejected_at'],
          rejected_comments: this.editAgreementData['rejected_comments'],
          deleted_at: this.editAgreementData['deleted_at'],
          created_at: this.editAgreementData['created_at'],
          updated_at: this.editAgreementData['updated_at'],
          unique_registrar: this.editAgreementData['unique_registrar'],
          new_reseller: this.editAgreementData['new_reseller'],
          currency: this.formData['currency_type'],
          agreement_detail: agtDetailsData
        }
      }
      
      let ptRes = await this.$axios.post(url, payload, {
        headers: {
          "apikey": process.env.VUE_APP_PT_API_KEY
        },
      });

      return ptRes;
    },
    async uploadAgreement() {
      let fileData = new FormData();
      fileData.append("new_reseller_id", this.formData["new_reseller_id"]);
      fileData.append("unique_registrar_id", this.formData["unique_registrar_id"]);
      fileData.append("type", this.formData["type"]);

      if (!this.imgLoaded || this.formData["isAppendedAgt"]) {
        fileData.append("file", this.$refs.agreementFile.files[0]);
      }

      fileData.append("start_date", this.formData["start_date"]);
      fileData.append("end_date", this.formData["end_date"]);
      fileData.append("agreement_name", this.formData["agreement_name"]);
      fileData.append("currency_id", this.formData["currency_type"]["value"]);
      fileData.append("conversion_rate", this.formData["conversion_rate"]);
      fileData.append("provision", this.formData["isProvisionalAgt"] ? 1 : 0);
      fileData.append("append", this.formData["isAppendedAgt"] ? 1 : 0);
      fileData.append("user_id", this.user_id);

      await this.$validator.validate().then(async (valid) => {
        if (!this.validateCashflow()) {
          this.cfError = true;
        } else if (valid) {
          this.openLoadingInAgtDiv();

          if(this.mode == 'edit') {
            try {
              var paytrackValidation = await this.validatePaytrack();
              var validationErrors = paytrackValidation.data.errors;
            }

            catch(error) {
              this.hideLoadingInAgtDiv();
            }
          }

          if(validationErrors && Object.keys(validationErrors).length) {
            let liStr = '';
            Object.keys(validationErrors).forEach((el, index) => {
              liStr += `<li>${index+1}. ${validationErrors[el]}</li><br>`
            })

            this.customPromptError = liStr;

            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
            // this.customPrompt["accept"] = await this.hideLoadingInAgtDiv();
            this.hideLoadingInAgtDiv();
          } else {
            let url = this.mode == 'edit' ? `/agreement/edit/${this.editAgreementData.id}` : this.isEdit ? `/agreement/request/${this.editAgreementData.id}` : `/agreement/request`;
  
            if(this.mode == 'edit' && this.$refs.agreementFile.files[0]) {
              this.$vs.dialog({
                color: "primary",
                title: this.mode == 'edit' ? "Edit Success" : "Upload Success",
                text: `All promos associated with this agreement will be connected with the new agreement.`,
                acceptText: "Okay",
                accept: async () => {
                  await this.$axiosSecure.post(url, fileData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((response) => {
                    if (response.data.type == "Success") {
                      this.agreementResponseId = response.data.data;
                      this.submitAgreementDetails();
                    } else if (response.data.type == "Error") {
                      this.$vs.dialog({
                        color: "danger",
                        title: "Error",
                        text: response.data.message,
                        acceptText: "Close",
                        accept: () => {},
                      });
                    }
                  })
                  .catch((error) => {
                    let errorMessage = "";
                    if(error.response && error.response.data && error.response.data.type && error.response.data.type == 'Error') {
                      errorMessage = error.response.data.message;
                    } else {
                      errorMessage = "Error occured while uploading the agreement, Please try again."
                    }
                    // Hide loader
                    this.hideLoadingInAgtDiv();
                    this.resetAgreement();
                    this.agreementPopupActive = false;
                    setTimeout(() => {
                      this.$vs.dialog({
                        color: "danger",
                        title: "Error",
                        text: errorMessage,
                        acceptText: "Close",
                        accept: () => {},
                      });
                    }, 200);
                  });
                },
              });
            } else {
              await this.$axiosSecure.post(url, fileData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                if (response.data.type == "Success") {
                  this.agreementResponseId = response.data.data;
                  this.submitAgreementDetails();
                } else if (response.data.type == "Error") {
                  this.$vs.dialog({
                    color: "danger",
                    title: "Error",
                    text: response.data.message,
                    acceptText: "Close",
                    accept: () => {},
                  });
                }
              })
              .catch((error) => {
                let errorMessage = "";
                if(error.response && error.response.data && error.response.data.type && error.response.data.type == 'Error') {
                  errorMessage = error.response.data.message;
                } else {
                  errorMessage = "Error occured while uploading the agreement, Please try again."
                }
                // Hide loader
                this.hideLoadingInAgtDiv();
                this.resetAgreement();
                this.agreementPopupActive = false;
                setTimeout(() => {
                  this.$vs.dialog({
                    color: "danger",
                    title: "Error",
                    text: errorMessage,
                    acceptText: "Close",
                    accept: () => {},
                  });
                }, 200);
              });
            }
          }
        } else {
          var errors = this.errors.collect();
          if (
            Object.keys(errors).filter((x) => x.indexOf("cf-") !== -1).length
          ) {
            this.cfError = true;
          } else {
            this.cfError = false;
          }
        }
      });
    },
    submitAgreementDetails() {
      var self = this;
      var agtDetailsData = this.agtDetails.map((x, index) => {
        return {
          agreement_detail_id: (self.mode == 'edit' && self.editAgreementData && self.editAgreementData.approved_at) ? undefined : (x.agreement_detail_id ? x.agreement_detail_id : null),
          agreement_request_id: this.mode == 'new' ? this.agreementResponseId : undefined,
          start_date: x.start_date,
          end_date: x.end_date,
          category: x.subCategory.value,
          sub_category: x.subCategory.label,
          amount: x.actual_amount,
          converted_amount: x.amount,
          total_amount:
            Math.round(this.formData["totalActualAmount"] * 100) / 100,
          total_converted_amount:
            Math.round(this.formData["totalAmount"] * 100) / 100,
          cashflow: self.formatCashFlow(index),
        };
      });

      let url = this.mode == 'edit'
      ? `/agreement/edit/details/${this.agreementResponseId}`
      : this.isEdit ? `/agreement/request/details/${this.agreementResponseId}` : `/agreement/request/details`;

      this.$axiosSecure
        .post(url, agtDetailsData)
        .then((response) => {
          this.tableRefresh();
          setTimeout(() => {
            this.$vs.dialog({
              color: "success",
              title: this.mode == 'edit' ? "Edit Success" : "Upload Success",
              text: this.mode == 'edit'
                ? "Agreement successfully edited."
                : "Agreement successfully uploaded.",
              acceptText: "Close",
              accept: () => {
                // this.$router.push("/agreement-requests");
              },
            });
          }, 200);
        })
        .catch((error) => {
          let errorMessage = "";
          if(error.response && error.response.data && error.response.data.type && error.response.data.type == 'Error') {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = "Error occured while uploading the agreement, Please try again."
          }
          setTimeout(() => {
            this.$vs.dialog({
              color: "danger",
              title: "Error",
              text: errorMessage,
              acceptText: "Close",
              accept: () => {},
            });
          }, 200);
        })
        .finally(() => {
          // Hide loader
          this.hideLoadingInAgtDiv();
          this.resetAgreement();
          this.agreementPopupActive = false;
        });
    },
    resetAgreement() {
      this.dataFetch = false;
      this.agreementModalHeading = 'Upload New Agreement';
      this.formData["type"] = "";
      this.formData["start_date"] = null;
      this.formData["end_date"] = null;
      this.formData["currency_type"] = "";
      this.formData["conversion_rate"] = "";
      this.formData["agreement_name"] = "";
      this.formData["client_id"] = null;
      this.formData["selected_currency"] = "";
      this.formData["totalActualAmount"] = "0";
      this.formData["totalAmount"] = "0";
      this.formData["new_reseller_id"] = "";
      this.formData["unique_registrar_id"] = "";
      this.formData["showCurrencySign"] = "";
      this.formData["partner_name"] = "";
      this.formData["selectedAgtName"]["selectedType"] = "";
      this.formData["selectedAgtName"]["selectedClient"] = "";
      this.formData["selectedAgtName"]["selectedStartMonth"] = "";
      this.formData["selectedAgtName"]["selectedStartMonthYear"] = "";
      this.formData["selectedAgtName"]["selectedEndMonth"] = "";
      this.formData["selectedAgtName"]["selectedEndMonthYear"] = "";
      this.formData["isProvisionalAgt"] = false;
      this.formData["isAppendedAgt"] = false;
      this.formData["versionFiles"] = [];
      this.cashFlowCounter = [];
      this.agreementResponseId = "";
      this.$refs.agreementFile.value = null;
      this.formData["fileName"] = "";
      this.formData["fileTypeError"] = "";
      this.formData["fileSizeError"] = "";
      this.formData["fileExtension"] = "";
      this.agtDetails.forEach((el) => {
        (el.checkBox = false),
          (el.start_date = null),
          (el.end_date = null),
          (el.category = ""),
          (el.subCategory = {}),
          (el.amount = ""),
          (el.actual_amount = ""),
          (el.totalCFAmount = "0"),
          (el.totalActualCFAmount = "0"),
          (el.tempCashFlow = [
            {
              checkBox: false,
              month: null,
              amount: "",
              converted_amount: "",
              monthPickerConfig: {
                disabledDates: {},
              },
            },
          ]),
          (el.cashFlow = [
            {
              checkBox: false,
              month: null,
              amount: "",
              converted_amount: "",
              monthPickerConfig: {
                disabledDates: {},
              },
            },
          ]);
      });
      this.cfCounter = 0;
      this.agtDetails.splice(1);
      this.dataFetch = true;
      this.editAgreementData = {};
      this.cfError = false;
      
    },
    tableRefresh() {
      this.$root.$emit("tableRefresh");
    },
    openCashFlow(counter) {
      if (
        this.agtDetails[counter]["start_date"] !== null &&
        this.agtDetails[counter]["end_date"] !== null &&
        this.formData["currency_type"].hasOwnProperty("value")
      ) {
        this.cashFlowPopupActive = true;
        this.cfCounter = counter;
      } else {
        this.$vs.notify({
          time: 6000,
          color: "danger",
          title: "Required",
          text: "Please enter the Start Date, End Date & Currency to add Cash Flow",
        });
      }
    },
    addCashFlowRow() {
      this.agtDetails[this.cfCounter]["tempCashFlow"].push({
        checkBox: false,
        month: null,
        amount: "",
        converted_amount: "",
        monthPickerConfig: {
          disabledDates: {},
        },
      });
      this.disableDatesMonthPicker();
    },
    getCashFlowRowIndex() {
      this.formData["cashFlowCounter"] = [];
      this.agtDetails[this.cfCounter]["tempCashFlow"].forEach(
        (element, index) => {
          if (element.checkBox == true) {
            var count = index;
            this.formData["cashFlowCounter"].push(count);
          }
        }
      );
    },
    deleteCashFlowRow() {
      var rowIndex = this.formData["cashFlowCounter"];
      this.agtDetails[this.cfCounter]["tempCashFlow"] = this.agtDetails[
        this.cfCounter
      ]["tempCashFlow"].filter((el, index) => !rowIndex.includes(index));

      if (!this.agtDetails[this.cfCounter]["tempCashFlow"].length) {
        this.agtDetails[this.cfCounter]["tempCashFlow"] = [
          {
            checkBox: false,
            month: null,
            amount: "",
            converted_amount: "",
            monthPickerConfig: {
              disabledDates: {},
            },
          },
        ];
        this.agtDetails[this.cfCounter]["totalActualCFAmount"] = "0";
        this.agtDetails[this.cfCounter]["totalCFAmount"] = "0";
      }
    },
    submitCashFlow() {
      let totalCashflowAmt = 0;

      this.agtDetails[this.cfCounter]["tempCashFlow"].map(
        (el) => (el.checkBox = false)
      );

      this.agtDetails[this.cfCounter]["tempCashFlow"].forEach(x => totalCashflowAmt += parseFloat(x.converted_amount));

      if(totalCashflowAmt != this.agtDetails[this.cfCounter]["amount"]) {
        this.$vs.dialog({
          color: "warning",
          title: "Warning",
          text: "The cashflow total amount does not match agreement detail's total amount!",
          acceptText: "Okay",
          accept: () => {},
        });
        
        // TODO: Revert to tempcashflow if totals don't match
        totalCashflowAmt = 0;
      } else {
        this.agtDetails[this.cfCounter]["cashFlow"] = JSON.parse(
          JSON.stringify(this.agtDetails[this.cfCounter]["tempCashFlow"])
        );

        this.cashFlowPopupActive = false;
  
        if (this.cfError) {
          this.cfError = false;
        }
      }

    }
  },
  mounted() {
    let self = this;

    self.$axiosSecure
      .get("/agreement/currency-rate")
      .then((response) => {
        self.formInit["currencyRates"] = response.data.message;
      })
      .catch((error) => {
        self.$vs.notify({
          color: "danger",
          title: "Something went wrong",
          text: "Please contact the server admin",
        });
        console.log(error);
      });

    this.$root.$on("openAgtPopup", (mode, id, data) => {
      this.agreementPopupActive = true;
      this.formData["client_id"] = id;
      this.mode = mode;
      this.dataFetch = true;
    });

    this.$root.$on("openEditAgtPopup", (mode, id, data) => {
      this.agreementPopupActive = true;
      this.mode = mode;
      this.formData["client_id"] = id;

      self.$set(self, "editAgreementData", data);
      self.formAgreementData(data);
      self.imgLoaded = true;
      this.agtNameFormations();
      self.formCategoryForAgreements(data).then((done) => {
        if (done) {
          self.formSubCategoryForAgreements(data).then((subDone) => {
            if (subDone) {
              self.$nextTick(() => {
                self.dataFetch = true;
              });
            }
          });
        }
      });

      if(mode == 'view') {
        if(!data.approved_at) {
          self.$set(self, 'agreementModalHeading', 'View Agreement Request');
        } else {
          self.$set(self, 'agreementModalHeading', 'View Agreement');
        }
      } else if(mode == 'edit'){
        self.$set(self, 'agreementModalHeading', 'Edit Agreement');
      } else {
        self.$set(self, 'isEdit', true);
        self.$set(self, 'agreementModalHeading', 'Edit Agreement Request');
      }
    });
  },
  beforeDestroy() {
    this.$validator.pause();

    if (this.$refs.vsCollapseItem) {
      for (let collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener("resize", collapseItem);
      }
    }
  },
  destroyed() {
    this.$root.$off("openAgtPopup");
    this.$root.$off("openEditAgtPopup");
  },
};
</script>

<style lang="scss">
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.con-vs-popup.cash-flow-popup {
  z-index: 530000;

  ~ .vs__dropdown-menu {
    z-index: 99990 !important;
    max-height: 200px !important;
  }
  .vs-popup {
    width: 60%;
    border-radius: 20px;

    &--close {
      margin-right: 2rem;
      margin-top: 2rem;
      font-size: 1.5em;
      padding: 0 !important;
      box-shadow: none !important;
    }
  }
  .vs-popup--header {
    background: transparent;
  }
  .vs-popup--title h3 {
    letter-spacing: -1.05px;
    font-size: 20px;
    line-height: 25px;
    font-family: "Work Sans", sans-serif;
    color: #000000;
    font-weight: 500;
  }
  .vs-popup--content {
    padding: 1rem 2rem;
    label {
      color: #000;
      font-size: 12px;
      line-height: 18px;
      font-family: "Work Sans", sans-serif;
      letter-spacing: -0.36px;
      font-weight: 500;
    }
  }
  .close-btn.includeIconOnly {
    width: 18px !important;
    height: 18px !important;
  }
  .form-field.agt-name-field {
    width: 400px !important;
  }
  .vs-collapse-item {
    .vs-collapse-item--header {
      line-height: 18px;
      padding-top: 0.7rem;
      padding-bottom: 0.7rem;
    }
    .form-actions {
      height: 37px;
    }
    &.open-item .vs-collapse-item--content {
      max-height: initial !important;
    }
  }
  .agreement-details-form.table-form {
    .table-head,
    .table-body {
      > li {
        width: 33.33%;
        &:nth-child(1) {
          width: 10%;
        }
        &:nth-child(3) {
          width: 45%;
        }
      }
    }
    .agtDetail-total {
      .table-head,
      .table-body {
        > li {
          width: 33.33%;
          &:nth-child(3) {
            width: 15%;
          }
        }
      }
    }

    .inputPrefix {
      .currency-sign {
        width: 40px;
        font-size: 13px;
      }
      .vs-con-input input {
        padding: 0.4rem 0.4rem 0.4rem 3.2rem !important;
      }
    }
    .total-amt-text {
      color: #000;
      font-weight: 500;
      font-family: "Work Sans", sans-serif;
      letter-spacing: -0.36px;
      padding: 10px;
    }
  }
  .upload-agt-btn {
    align-items: center;
    display: flex;
    margin-top: 20px;
  }
}

.vs-checkbox {
  border: 1px solid #d1d1d1 !important;
  width: 15px;
  height: 15px;
}

.agreement-details-table {
  border: 0.5px solid #e8e8e8;
  border-collapse: collapse;

  tr:last-child {
    td {
      padding: 0.5rem;
    }
  }

  th {
    text-align: center;
    background-color: #F7F7F7;
    padding: 0.75rem 0.5rem;
    border-right: 1px solid #EEEEEE;
  }

  td {
    text-align: center;
    // padding: 0.25rem;
    border-right: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
  }

  input {
    border: none !important;
    text-align: center;
  }

  .inputPrefix .vs-con-input input {
    padding-left: 2.8rem;
  }

  .vs-input--input.normal:focus {
    border: none !important;
  }

  .vs__dropdown-toggle {
    border: none !important;
  }

  .total-amt-text {
      color: #000;
      font-weight: 500;
      font-family: "Work Sans", sans-serif;
      letter-spacing: -0.36px;
      padding: 10px;
    }
}

.common-details {
  width: 95%;
}

.offset-3 {
    justify-content: center;
    display: flex;
    align-items: center;
    margin-left: 33.333333333333336%;
    width: 33.333333333333336%;
}
</style>